import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	Input,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { TermsAndConditionsVersion } from "@obg/ngx.common";
import { SessionSelector } from "@obg/ngx.core";
import { RouterState } from "@obg/ngx.router";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";

@Component({
	selector: "obg-m-terms-and-conditions-current-version-container",
	templateUrl: "./terms-and-conditions-current-version.container.html",
	styleUrls: ["./terms-and-conditions-current-version.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class TermsAndConditionsCurrerntVersionContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-terms-and-conditions-current-version") class = true;

	@Input() document: string | undefined;
	@Input() currentVersion: TermsAndConditionsVersion | undefined;

	updatedTermsAndConditions$: Subscription | undefined;
	showUpdatedTermsAndConditions = false;
	isBusy = false;

	constructor(
		private store: Store<RouterState>,
		private sessionSelector: SessionSelector,
		private changeDetector: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.updatedTermsAndConditions$ = this.store
			.pipe(
				select(this.sessionSelector.getTermsAndConditionsToken()),
				tap((token) => (this.showUpdatedTermsAndConditions = !!token))
			)
			.subscribe(() => this.changeDetector.markForCheck());
	}

	ngOnDestroy() {
		if (this.updatedTermsAndConditions$) {
			this.updatedTermsAndConditions$.unsubscribe();
		}
	}

	changeBusyState(isBusy: boolean) {
		this.isBusy = isBusy;
	}
}
